import { Users, Heart, Wine, Utensils } from "lucide-react";

const Experience = () => {
  const experiences = [
    { icon: Users, text: "Tapear con amigos" },
    { icon: Heart, text: "Cenar en pareja" },
    { icon: Wine, text: "Disfrutar de un buen vino después del trabajo" },
    { icon: Utensils, text: "Descubrir nuevos sabores" },
  ];

  return (
    <section id="experiencia" className="section-padding bg-[#F9F7F2]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="img-zoom relative">
              <img
                src="https://images.unsplash.com/photo-1672833634993-a7ce02f7adbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxwZW9wbGUlMjBkaW5pbmclMjByZXN0YXVyYW50JTIwd2luZSUyMHRvYXN0fGVufDB8fHx8MTc3MzM0NzQ0N3ww&ixlib=rb-4.1.0&q=85"
                alt="Clientes disfrutando en Abacería Como en Casa"
                className="w-full h-[500px] object-cover"
              />
              {/* Decorative frame */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#C5A059] -z-10" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="font-accent text-[#800020] text-lg mb-4">
              Nuestra filosofía
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-6">
              Un lugar para disfrutar sin prisa
            </h2>

            <div className="gold-border-left mb-8">
              <p className="font-body text-[#1A1A1A]/80 leading-relaxed mb-4">
                En Abacería Como en Casa creemos que la gastronomía se disfruta mejor
                cuando se comparte.
              </p>
              <p className="font-body text-[#1A1A1A]/80 leading-relaxed">
                Nuestro espacio combina la tradición de las abacerías andaluzas con una
                propuesta gastronómica basada en productos de máxima calidad, vinos
                seleccionados y un ambiente pensado para disfrutar.
              </p>
            </div>

            <p className="font-accent text-lg text-[#1A1A1A] mb-4">
              Aquí podrás venir a:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {experiences.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-4 bg-white border border-[#DCD7CC] hover:border-[#C5A059] transition-colors"
                  data-testid={`experience-item-${index}`}
                >
                  <item.icon size={20} className="text-[#800020] flex-shrink-0" />
                  <span className="font-body text-[#1A1A1A]">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
